var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$mq !== "mobile"
    ? _c(
        "div",
        {
          staticClass: "hero-banner__container",
          class: _vm.block.mobileBgColor
        },
        [
          _vm.block.enableCta
            ? _c(
                "a",
                {
                  staticClass: "hero-banner",
                  class: [
                    _vm.layoutHorizontal,
                    _vm.layoutVertical,
                    _vm.textAlign
                  ],
                  style: _vm.backgroundStyles,
                  attrs: { href: _vm.block.ctaUrl }
                },
                [
                  _vm.block.overlayEnable
                    ? _c("div", {
                        staticClass: "hero-banner__overlay",
                        class: _vm.block.overlayColor,
                        style: _vm.overlayStyles
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "hero-banner__content-container" }, [
                    _c("div", { staticClass: "hero-banner__content" }, [
                      _vm.block.heading
                        ? _c(
                            "h2",
                            {
                              staticClass: "h2 about-banner__heading",
                              class: _vm.block.headingColor
                            },
                            [_vm._v(_vm._s(_vm.block.heading))]
                          )
                        : _vm._e(),
                      _vm.block.subHeading
                        ? _c(
                            "h3",
                            {
                              staticClass: "subheader hero-banner__subheading",
                              class: _vm.block.subHeadingColor
                            },
                            [_vm._v(_vm._s(_vm.block.subHeading))]
                          )
                        : _vm._e(),
                      _vm.block.copy
                        ? _c(
                            "p",
                            {
                              staticClass: "body-md hero-banner__body-copy",
                              class: _vm.block.copyColor
                            },
                            [_vm._v(_vm._s(_vm.block.copy))]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "hero-banner__cta-wrapper" },
                        [
                          _vm.block.ctaLayout.includes("button")
                            ? _c(
                                "v-button",
                                {
                                  staticClass: "hero-banner__cta",
                                  class: _vm.block.ctaLayout,
                                  attrs: { href: _vm.block.ctaUrl, tag: "a" }
                                },
                                [_vm._v(_vm._s(_vm.block.ctaText))]
                              )
                            : _vm._e(),
                          _vm.block.ctaLayout.includes("link")
                            ? _c(
                                "v-link",
                                {
                                  staticClass: "hero-banner__cta",
                                  class: _vm.block.ctaLayout,
                                  attrs: { href: _vm.block.ctaUrl }
                                },
                                [_vm._v(_vm._s(_vm.block.ctaText))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "hero-banner",
                  class: [
                    _vm.layoutHorizontal,
                    _vm.layoutVertical,
                    _vm.textAlign
                  ],
                  style: _vm.backgroundStyles
                },
                [
                  _vm.block.overlayEnable
                    ? _c("div", {
                        staticClass: "hero-banner__overlay",
                        class: _vm.block.overlayColor,
                        style: _vm.overlayStyles
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "hero-banner__content-container" }, [
                    _c("div", { staticClass: "hero-banner__content" }, [
                      _vm.block.heading
                        ? _c(
                            "h2",
                            {
                              staticClass: "h2 about-banner__heading",
                              class: _vm.block.headingColor
                            },
                            [_vm._v(_vm._s(_vm.block.heading))]
                          )
                        : _vm._e(),
                      _vm.block.subHeading
                        ? _c(
                            "h3",
                            {
                              staticClass: "subheader hero-banner__subheading",
                              class: _vm.block.subHeadingColor
                            },
                            [_vm._v(_vm._s(_vm.block.subHeading))]
                          )
                        : _vm._e(),
                      _vm.block.copy
                        ? _c(
                            "p",
                            {
                              staticClass: "body-md hero-banner__body-copy",
                              class: _vm.block.copyColor
                            },
                            [_vm._v(_vm._s(_vm.block.copy))]
                          )
                        : _vm._e()
                    ])
                  ])
                ]
              )
        ]
      )
    : _c("div", { staticClass: "hero-banner__container" }, [
        _c(
          "div",
          {
            staticClass: "hero-banner",
            class: [_vm.layoutHorizontal, _vm.textAlign]
          },
          [
            _c("div", {
              staticClass: "hero-banner__image-mobile",
              style: _vm.backgroundStylesMobile
            }),
            _c(
              "div",
              {
                staticClass: "hero-banner__content",
                class: _vm.block.mobileBgColor
              },
              [
                _vm.block.heading
                  ? _c(
                      "h2",
                      {
                        staticClass: "h2 about-banner__heading",
                        class: _vm.block.headingColor
                      },
                      [_vm._v(_vm._s(_vm.block.heading))]
                    )
                  : _vm._e(),
                _vm.block.subHeading
                  ? _c(
                      "h3",
                      {
                        staticClass: "subheader hero-banner__subheading",
                        class: _vm.block.subHeadingColor
                      },
                      [_vm._v(_vm._s(_vm.block.subHeading))]
                    )
                  : _vm._e(),
                _vm.block.copy
                  ? _c(
                      "p",
                      {
                        staticClass: "body-md hero-banner__body-copy",
                        class: _vm.block.copyColor
                      },
                      [_vm._v(_vm._s(_vm.block.copy))]
                    )
                  : _vm._e(),
                _vm.block.enableCta
                  ? _c(
                      "div",
                      { staticClass: "hero-banner__cta-wrapper" },
                      [
                        _vm.block.ctaLayout.includes("button")
                          ? _c(
                              "v-button",
                              {
                                staticClass: "hero-banner__cta",
                                class: _vm.block.ctaLayout,
                                attrs: { href: _vm.block.ctaUrl, tag: "a" }
                              },
                              [_vm._v(_vm._s(_vm.block.ctaText))]
                            )
                          : _vm._e(),
                        _vm.block.ctaLayout.includes("link")
                          ? _c(
                              "v-link",
                              {
                                staticClass: "hero-banner__cta",
                                class: _vm.block.ctaLayout,
                                attrs: { href: _vm.block.ctaUrl }
                              },
                              [_vm._v(_vm._s(_vm.block.ctaText))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }